import Layout from "../Layout";
import FrontPageLayout from "../FrontPageLayout";
import ViewArticleLayout from "../ViewArticleLayout";

export default [
  {
    path: "/",
    name: "frontpagelayout",
    redirect: { name: "frontpage" },
    component: Layout,
    children: [
      {
        path: "front/:articleid?",
        name: "frontpage",
        component: FrontPageLayout
      },
      {
        path: "view/:articleid?",
        name: "viewarticle",
        component: ViewArticleLayout
      }
    ]
  }
];
